import { SocialLinkButton } from "../socialButton/SocialButton"
import CampaignLogo from "../../assets/campaign-logo.svg"
import React from "react"
import { Link } from "react-router-dom"
import { useLocale } from "../../services/DataContext"

interface HeaderProps {
  className?: string;
}

export const Header: React.FC<HeaderProps> = (props) => {
  const l: any = useLocale();
  return <header className={`header container ${props.className || ""}`}>
    <div className="header__row row">
      <div className="header__campaign-logo hide-on-small">
        <Link to="/">
          <img src={CampaignLogo} alt="" />
        </Link>
      </div>
      <div className="header__content">
        <SocialLinkButton href={`https://twitter.com/intent/tweet?url=https://www.planet7casino.com/hits-and-misses/&text=${encodeURIComponent(l["twitterContent"])}`}>
          <span className="icon-twitter"></span>
        </SocialLinkButton>
      </div>
    </div>
  </header>
}